module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/162.17887df7.png";